// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__eYZa1","list":"style_list__yx0Xr","item":"style_item__2MOzU","label":"style_label__Spx9C","title":"style_title__ZHJwP"};